export const ALERT_ERROR_NAME = {
    main: 'mainErrorAlert',
    dialogTabDetails: 'dialogTabDetailsErrorAlert',
    dialogTabMembers: 'dialogTabMembersErrorAlert',
    dialogTabServices: 'dialogTabServicesErrorAlert',
    dialogTabChangeLog: 'dialogTabChangeLogErrorAlert',
    dialogTabSubscriptions: 'dialogTabSubscriptionsErrorAlert',
    dialogTabConfiguration: 'dialogTabConfigurationErrorAlert',
    dialogTabChildCustomers: 'dialogTabChildCustomersErrorAlert'
}
